<template>
  <div class="flex flex-col">
    <div class="fixed top-[60px] w-full z-10">
      <template v-for="(_, name) in $slots" :key="name">
        <slot v-if="checkName(name)" :name="name"></slot>
      </template>
    </div>
    <div class="mt-24 lg:container lg:mx-auto">
      <slot />
    </div>
  </div>
</template>
<script setup>
  const checkName = (name) => {
    return name.startsWith('alert-');
  };
</script>
